/**
 * Persistencia de tours guiados (Driver.js v1) en localStorage.
 *
 * Claves por tenant para no mezclar el estado entre organizaciones que
 * compartan el mismo navegador (misma consideración que `onboardingState`).
 */
const SEEN_KEY_PREFIX = 'driver-tour:seen:'
const AUTO_SUPPRESSED_KEY_PREFIX = 'driver-tour:auto-suppressed:'

function tenantKey(prefix: string, tenantId?: string | null, tourId?: string): string | null {
  if (!tenantId) return null
  return `${prefix}${tenantId}:${tourId ?? '*'}`
}

export function isTourSeen(tenantId?: string | null, tourId?: string): boolean {
  const key = tenantKey(SEEN_KEY_PREFIX, tenantId, tourId)
  if (!key) return false
  try {
    return localStorage.getItem(key) === 'true'
  } catch {
    return false
  }
}

export function markTourSeen(tenantId?: string | null, tourId?: string): void {
  const key = tenantKey(SEEN_KEY_PREFIX, tenantId, tourId)
  if (!key) return
  try {
    localStorage.setItem(key, 'true')
  } catch {
    /* almacenamiento no disponible: el tour simplemente se volverá a ofrecer */
  }
}

/** Reinicia el estado de un tour concreto para que vuelva a ofrecerse. */
export function resetTour(tenantId?: string | null, tourId?: string): void {
  const key = tenantKey(SEEN_KEY_PREFIX, tenantId, tourId)
  if (!key) return
  try {
    localStorage.removeItem(key)
  } catch {
    /* noop */
  }
}

/**
 * El cliente pulsó "Omitir guía": la guía ya no se abre sola en este tenant.
 * Sigue disponible desde el botón "Guía" del header.
 */
export function suppressAutoTours(tenantId?: string | null): void {
  const key = tenantKey(AUTO_SUPPRESSED_KEY_PREFIX, tenantId)
  if (!key) return
  try {
    localStorage.setItem(key, 'true')
  } catch {
    /* noop */
  }
}

export function isAutoTourSuppressed(tenantId?: string | null): boolean {
  const key = tenantKey(AUTO_SUPPRESSED_KEY_PREFIX, tenantId)
  if (!key) return false
  try {
    return localStorage.getItem(key) === 'true'
  } catch {
    return false
  }
}

/** Vuelve a permitir el arranque automático de la guía de bienvenida. */
export function resetAutoTourSuppression(tenantId?: string | null): void {
  const key = tenantKey(AUTO_SUPPRESSED_KEY_PREFIX, tenantId)
  if (!key) return
  try {
    localStorage.removeItem(key)
  } catch {
    /* noop */
  }
}
